import React, { useEffect, useState, useContext, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledTablePmePrograma } from "../../../styled-components/StyledTablePmePrograma.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { DynamicInput } from "../../../components/DynamicInput";
import { StldRow } from "../../../styled-components/StldRow.style";
import { useForm } from 'react-hook-form';
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as moment from 'moment'
import Flex from '@react-css/flex';
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { IconRefresh } from "../../../svg";
import { PaginationCustom } from "../../../components/PaginationCustom";
import { genericList } from "../../../services/genericList";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const getListaProgramas = async (formValues, currentPage, pageSize) => {
    let list = null;
    let params = '';
    let _IdEmpresa = formValues.empresa;

    if (formValues.empresa == 2) {
        _IdEmpresa = 2
    }
    else if (formValues.empresa == -1) {
        _IdEmpresa = 0
    }

    // params = {
    //     Status: true,
    //     nomePrograma: formValues?.nomePrograma || null,
    //     currentPage: currentPage || 1,
    //     pageSize: pageSize || 10,
    //     idEmpresa: _IdEmpresa
    // };

    params += `&idEmpresa=${_IdEmpresa}`;

    try {
        const response = await api.get(`PmePrograma?${params}`);
        list = response.data || [];
        return list;
    } catch (err) {
        return [];
    }
}

export const PmeProgramas = () => {
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const history = useHistory();

    const { register, handleSubmit, reset, getValues } = useForm();
    const [searchReadOnly, setSearchReadOnly] = useState(false);
    const [assunto, setAssunto] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [ListaData, setListaData] = useState(null);    
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);

    const [nomePrograma, setNomePrograma] = useState(null);

    var [empresasUser, setEmpresasUser] = useState([]);
    var [idEmpresaIndexTab, setIdEmpresaIndexTab] = useState(0);

    const carregarProgramas = async () => {
        setIsLoading(true);
        try {
            // Transforma o Index da Tab no ID real da empresa para a API
            // Index 0 = Critério (ID 1)
            // Index 1 = Adjuster (ID 2)
            // Index 2 = Todos (ID -1)
            
            let idEmpresaParaFiltro = 1; // Padrão Critério (Aba 0)

            if (idEmpresaIndexTab === 1) {
                idEmpresaParaFiltro = 2;
            } else if (idEmpresaIndexTab === 2) {
                idEmpresaParaFiltro = -1;
            }

            const formValues = {
                nomePrograma: nomePrograma || null,
                currentPage: currentPage || 1,
                pageSize: pageSize || 10,
                empresa: idEmpresaParaFiltro
            };

            const lista = await getListaProgramas(formValues, currentPage, pageSize);
            console.log('lista', lista);
            setListaData(lista);
        } finally {
            setIsLoading(false);
        }
    };
    
    const getTextStatus = (status) => {
        const textStatus = "ATIVO";
        if(status == 0) {
            textStatus = "INATIVO";
        }
        return textStatus;
    };

    const getSearch = async (currentValue, value, pageSize) => {
        try {
            setIsLoading(true); // Exibe um indicador de carregamento
    
            const response = await api.get('PmePrograma/search', {
                params: {
                    nomePrograma: currentValue, // O valor da busca
                    pageSize: pageSize || 10, // Quantidade de itens por página
                    currentPage: value || 1, // Página atual
                },
            });

            console.log('response', response);
    
            setListaData(response);
            setIsLoading(false);
        } catch (error) {
            console.error('Erro ao buscar programas:', error.message || error);
            Swal.fire({
                title: "Erro",
                text: "Não foi possível buscar os programas. Tente novamente.",
                icon: "error",
                confirmButtonText: "OK",
            });
            setIsLoading(false);
        }
    }

    const refreshData = async () => {
        await carregarProgramas();
    }

    const deletePrograma = async (idPrograma) => {
        try {
            await api.delete(`PmePrograma/${idPrograma}`);
            
            Swal.fire({
                title: "Sucesso",
                text: "Programa Removido com sucesso!",
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
            });
    
            await carregarProgramas();
        } catch (error) {
            Swal.fire({
                title: "Erro",
                text: "Não foi possível remover o programa. Tente novamente.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    const handleDeletePrograma = (idPrograma) => {
        Swal.fire({
            title: "Deseja realmente remover este programa?",
            text: "Essa ação não poderá ser desfeita!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Sim, remover!",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                deletePrograma(idPrograma);
            }
        });
    };

    const getacoes = (idPrograma) => {
        return (
            <Flex >
                <span className="cursor-pointer color-icon-default m-1" onClick={() => setRedirectFormEdit(idPrograma)} title="Editar este programa">
                    <i className="fa fa-edit" aria-hidden="true"></i>
                </span>
                <span className="cursor-pointer color-icon-default m-1" onClick={() => { }} title="Copiar">
                    <i className="fa fa-copy" aria-hidden="true"></i>
                </span>
                <span className="cursor-pointer color-icon-default m-1" onClick={() => { handleDeletePrograma(idPrograma) }} title="Excluir">
                    <i className="fa fa-ban"></i>
                </span>
            </Flex>
        );

    };

    const setRedirectForm = () => {
        history.push("/pme-programas/novo");
    }

    const setRedirectFormEdit = (idPrograma) => {
        history.push(`/pme-programas/edit/${idPrograma}`);
    }

    const filtroEmpresa = async (currentValue, indexTab) => {
        //idEmpresaIndexTab = indexTab;
        setIdEmpresaIndexTab(indexTab);

        const valuesForm =  getValues();
        let formValues = {
            empresa: currentValue
        };

        const result = await getListaProgramas(formValues);
        setListaData(result);
    } 

    const handleTabSelect = (index) => {
        // Apenas atualiza o estado. O useEffect vai perceber e chamar a API.
        setIdEmpresaIndexTab(index);
        
        // Zera a paginação ao trocar de aba para evitar bugs
        setCurrentPage(1); 
    };

    useEffect(() => {
        checkIsMultEmpresaUser();
    }, []);

    useEffect(() => {
        const asyncFn = async () => {
            await carregarProgramas();        
        }
        asyncFn();
    }, [idEmpresaIndexTab, currentPage, pageSize]);

    const checkIsMultEmpresaUser = (value) => {
        const empresas = localStorage.getItem('empresasUsuario') ?
            JSON.parse(localStorage.getItem('empresasUsuario'))
            : [];

        if (empresas) {
            empresasUser = empresas;
            setEmpresasUser(empresasUser);
        }

        if (empresasUser.length > 1) {
            idEmpresaIndexTab = 0;
            setIdEmpresaIndexTab(idEmpresaIndexTab);
        } else {
            switch (empresasUser[0]) {
                case '1':
                case 1:
                    setIdEmpresaIndexTab(0);
                    break;
                case '2':
                case 2:
                    setIdEmpresaIndexTab(1);
                    break;
                default:
                    setIdEmpresaIndexTab(2);
                    break;

            }
        }


    }

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">PME - Programas </h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                    </div>
                    <div className="card">
                        <div className="row justify-content-between mb-3">
                            {/* <div className="col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                <DynamicInput placeholder={''} componentReadOnly={searchReadOnly} label={'Pesquisar'} name={'Search'} paramMethod={getSearch} />
                            </div> */}
                            <div className="col-sm-12 col-md-2 col-lg-2  pt-2">
                                <input type="button" className='default-button-red-block btn-block' value='Novo' onClick={setRedirectForm} />
                            </div>
                        </div>
                        <StldRow>
                            <Flex>
                                <StyledForm style={{ width: "100%" }}>
                                    <Tabs className="timesheet m-0" selectedIndex={idEmpresaIndexTab} onSelect={handleTabSelect}>
                                        {empresasUser?.length > 1 ? <TabList>
                                            <Tab>Critério Experts</Tab>
                                            <Tab>Adjusters</Tab>
                                            <Tab>Todos</Tab>
                                        </TabList> : ''}
                                        <TabPanel>
                                            <StyledTablePmePrograma>
                                                <StyledTablePage>
                                                {
                                                    ListaData?.data?.length > 0 ? 
                                                    (
                                                        <div className="table-scroll font-0-9x table-bordered table-container">
                                                            <table className="table table-width">
                                                                <thead>
                                                                    <tr className="table-legend-info">
                                                                        <th key="ac">Ações</th>
                                                                        {/* <th key="idPrograma">ID</th> */}
                                                                        <th key="nomePrograma">Nome do Programa</th>
                                                                        <th key="inicio_termino" colSpan={2}>Vigência</th>
                                                                        <th key="status">Status</th>
                                                                        <th key="contemplados">Contemplados</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {ListaData.data
                                                                    .sort((a, b) => new Date(b.dataInicio) - new Date(a.dataInicio)) // Ordena do mais recente para o mais antigo
                                                                    .map((programa, index) => (
                                                                        <tr key={index}>
                                                                            <td className="text-center">{ getacoes(programa.idPrograma) }</td>
                                                                            {/* <td className="text-center">{ programa.idPrograma }</td> */}
                                                                            <td className="text-center">{ programa.nomePrograma }</td>
                                                                            <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataInicio)) }</td>
                                                                            <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataFim)) }</td>
                                                                            <td className="text-center">{ getTextStatus(programa.status) }</td>
                                                                            <td className="text-center">{ programa.contagemProfissionais }</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <StldColumn xs="12" sm="12" md="12">
                                                            <div className="alert alert-warning" role="alert">
                                                                Atenção! Nenhum resultado encontrado!
                                                            </div>
                                                        </StldColumn>
                                                    )
                                                }
                                                </StyledTablePage>
                                            </StyledTablePmePrograma>
                                        </TabPanel>
                                        <TabPanel>
                                            <StyledTablePmePrograma>
                                                <StyledTablePage>
                                                {
                                                    ListaData?.data?.length > 0 ? 
                                                    (
                                                        <div className="table-scroll font-0-9x table-bordered table-container">
                                                            <table className="table table-width">
                                                                <thead>
                                                                    <tr className="table-legend-info">
                                                                        <th key="ac">Ações</th>
                                                                        {/* <th key="idPrograma">ID</th> */}
                                                                        <th key="nomePrograma">Nome do Programa</th>
                                                                        <th key="inicio_termino" colSpan={2}>Vigência</th>
                                                                        <th key="status">Status</th>
                                                                        <th key="contemplados">Contemplados</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {ListaData.data
                                                                    .sort((a, b) => new Date(b.dataInicio) - new Date(a.dataInicio)) // Ordena do mais recente para o mais antigo
                                                                    .map((programa, index) => (
                                                                        <tr key={index}>
                                                                            <td className="text-center">{ getacoes(programa.idPrograma) }</td>
                                                                            {/* <td className="text-center">{ programa.idPrograma }</td> */}
                                                                            <td className="text-center">{ programa.nomePrograma }</td>
                                                                            <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataInicio)) }</td>
                                                                            <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataFim)) }</td>
                                                                            <td className="text-center">{ getTextStatus(programa.status) }</td>
                                                                            <td className="text-center">{ programa.contagemProfissionais }</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <StldColumn xs="12" sm="12" md="12">
                                                            <div className="alert alert-warning" role="alert">
                                                                Atenção! Nenhum resultado encontrado!
                                                            </div>
                                                        </StldColumn>
                                                    )
                                                }
                                                </StyledTablePage>
                                            </StyledTablePmePrograma>
                                        </TabPanel>
                                        <TabPanel>
                                            <StyledTablePmePrograma>
                                                <StyledTablePage>
                                                {
                                                    ListaData?.data?.length > 0 ? 
                                                    (
                                                        <div className="table-scroll font-0-9x table-bordered table-container">
                                                            <table className="table table-width">
                                                                <thead>
                                                                    <tr className="table-legend-info">
                                                                        <th key="ac">Ações</th>
                                                                        {/* <th key="idPrograma">ID</th> */}
                                                                        <th key="nomePrograma">Nome do Programa</th>
                                                                        <th key="inicio_termino" colSpan={2}>Vigência</th>
                                                                        <th key="status">Status</th>
                                                                        <th key="contemplados">Contemplados</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {ListaData.data
                                                                    .sort((a, b) => new Date(b.dataInicio) - new Date(a.dataInicio)) // Ordena do mais recente para o mais antigo
                                                                    .map((programa, index) => (
                                                                        <tr key={index}>
                                                                            <td className="text-center">{ getacoes(programa.idPrograma) }</td>
                                                                            {/* <td className="text-center">{ programa.idPrograma }</td> */}
                                                                            <td className="text-center">{ programa.nomePrograma }</td>
                                                                            <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataInicio)) }</td>
                                                                            <td className="text-center">{ new Intl.DateTimeFormat('pt-BR').format(new Date(programa.dataFim)) }</td>
                                                                            <td className="text-center">{ getTextStatus(programa.status) }</td>
                                                                            <td className="text-center">{ programa.contagemProfissionais }</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <StldColumn xs="12" sm="12" md="12">
                                                            <div className="alert alert-warning" role="alert">
                                                                Atenção! Nenhum resultado encontrado!
                                                            </div>
                                                        </StldColumn>
                                                    )
                                                }
                                                </StyledTablePage>
                                            </StyledTablePmePrograma>
                                        </TabPanel>
                                    </Tabs>
                                </StyledForm>
                            </Flex>
                        </StldRow>
                        {/* {(() => {
                            if (ListaData != null) {
                                return (
                                    <PaginationCustom isMobile={isMobile}
                                        isDesktop={isDesktop}
                                        length={ListaData?.data?.page?.length ?? 0}
                                        recordsTotal={ListaData?.data?.page?.recordsTotal ?? 0}
                                        currentPage={currentPage ?? 0}
                                        formData={carregarProgramas}
                                        pageSize={pageSize ?? 0}
                                        setPageSize={setPageSize}
                                        setPage={(page) => setCurrentPage(page)} />
                                )
                            }
                            return null
                        })()} */}
                    </div>
                </StyledDefaultPage>
            </main>
        </section >
    );
};


export const ProgramasPmePage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <PmeProgramas />

                </>
            )}
        </>
    );
};
